<template>
  <div>
    <!-- Edit Question -->
    <v-row class="ma-0 mb-3">
      <v-spacer />
      <v-btn
        color="primary"
        class="min-width-1"
        @click="handleEditItem(itemDetail)"
        >{{ $t("EDIT") }}</v-btn
      >
    </v-row>
    <component
      :is="`ViewDetail${isValue}`"
      :probleType="probleType"
      :item="itemDetail"
      :isValue="isValue"
    />
    <v-row class="ma-0 mt-6">
      <v-spacer />
      <v-btn class="min-width-1" @click="$router.go(-1)">{{
        $t("BACK")
      }}</v-btn>
    </v-row>
  </div>
</template>

<script>
import Dialog from "@/components/Dialog/Dialog";
import mixin from "@/mixin";
import { getDetailQuestion } from "@/api/Question.api";
import ViewDetailChoices from "@/views/listGeneral/ViewDetail/ViewDetailChoices";
import ViewDetailSort from "@/views/listGeneral/ViewDetail/ViewDetailSort";
import ViewDetailConjugation from "@/views/listGeneral/ViewDetail/ViewDetailConjugation";
import ViewDetailKanji from "@/views/listGeneral/ViewDetail/ViewDetailKanji";
import ViewDetailShortSentences from "@/views/listGeneral/ViewDetail/ViewDetailShortSentences";
import ViewDetailLongSentences from "@/views/listGeneral/ViewDetail/ViewDetailLongSentences";
import ViewDetailComprehension from "@/views/listGeneral/ViewDetail/ViewDetailComprehension";
import ViewDetailMultiRead from "@/views/listGeneral/ViewDetail/ViewDetailMultiRead";
export default {
  store: ["formGeneral"],
  components: {
    Dialog,
    ViewDetailChoices,
    ViewDetailSort,
    ViewDetailConjugation,
    ViewDetailKanji,
    ViewDetailShortSentences,
    ViewDetailLongSentences,
    ViewDetailComprehension,
    ViewDetailMultiRead,
  },
  mixins: [mixin.ValidateGeneral],
  data() {
    return {
      dialogViewGeneral: false,
      isValue: "Choices",
      probleType: [
        { text: "語彙・文法：4択", type: "write", key: "Choices" },
        { text: "語彙・文法：並び替え", type: "write", key: "Sort" },
        { text: "語彙・文法：ダイヤル入力", type: "write", key: "Conjugation" },
        { text: "漢字読み", type: "write", key: "Kanji" },
        { text: "短文聴解", type: "listen", key: "ShortSentences" },
        { text: "長文聴解", type: "listen", key: "LongSentences" },
        { text: "読解：4択", type: "read", key: "Comprehension" },
        { text: "読解：複数選択", type: "read", key: "MultiRead" },
      ],
      itemDetail: {},
    };
  },
  computed: {
    parent() {
      var parent = "";
      if (this.$route.name == "Detail General OF Season") {
        parent = "season";
      } else if (this.$route.name == "Detail General OF Chapter") {
        parent = "chapter";
      } else if (this.$route.name == "Detail General OF Section") {
        parent = "section";
      }
      return parent;
    },
    paramsUpdate() {
      var parent = "";
      const { query } = this.$route;
      if (this.$route.name == "Detail General OF Season") {
        parent = {
          name: "Update General OF Season",
          params: { season: this.$route.params.season },
          query,
        };
      } else if (this.$route.name == "Detail General OF Chapter") {
        parent = {
          name: "Update General OF Chapter",
          params: { chapter: this.$route.params.chapter },
          query,
        };
      } else if (this.$route.name == "Detail General OF Section") {
        parent = {
          name: "Update General OF Section",
          params: { section: this.$route.params.section },
          query,
        };
      }
      return parent;
    },
  },
  async created() {
    await this.handleGetDetail();
  },
  methods: {
    async handleGetDetail() {
      let params = {
        sub_key: this.$route.params[this.parent],
        id: this.$route.params.id,
        parent: this.parent,
      };
      await getDetailQuestion(params).then((response) => {
        const {
          type_value,
          name,
          lead_sentence,
          verb,
          list_answer,
          answer_correct,
          script,
          image_url,
          audio_url,
          sub_question: { question1, question2 },
        } = response.result;
        this.itemDetail = response.result;
        this.isValue = type_value;
        this.formGeneral.leadSentence = lead_sentence;
        // If type = Choices || Sort
        if (type_value == "Choices" || type_value == "Sort") {
          if (typeof name[0] == "string") {
            this.formGeneral.name = [name];
          } else {
            this.formGeneral.name = name;
          }
          this.formGeneral.answers.forEach(
            (e, index) => (e.value = response.result[`answer${index + 1}`])
          );
          this.formGeneral.isAnsewr = answer_correct[0];
        }
        // If type = Conjugation
        if (type_value == "Conjugation") {
          this.formGeneral.name1 = list_answer.sentence_answer[0];
          this.formGeneral.name2 = list_answer.sentence_answer[1];
          this.formGeneral.verb = verb;
          this.formGeneral.answersConjugation = list_answer.answer[0];
          this.formGeneral.wrongAnswersConjugation = list_answer.answer[1];
          this.formGeneral.isAnsewr = answer_correct[0];
        }
        // If type = kanji
        if (type_value == "Kanji") {
          this.formGeneral.name1 = name[0][0];
          this.formGeneral.kanji = name[0][1];
          this.formGeneral.name2 = name[0][2];
          this.formGeneral.isAnsewr = answer_correct[0];
          this.formGeneral.answers.forEach(
            (e, index) => (e.value = response.result[`answer${index + 1}`])
          );
        }

        // If type = ShortSentences
        if (type_value == "ShortSentences") {
          this.formGeneral.isAnsewr = answer_correct[0];
          console.log("script: ", script);
          this.formGeneral.script = script;
          this.formGeneral.audio = audio_url ? { fileUrl: audio_url } : null;
          this.formGeneral.answers.forEach(
            (e, index) => (e.value = response.result[`answer${index + 1}`])
          );
        }

        // If type = LongSentences
        if (type_value == "LongSentences") {
          this.formGeneral.audio = audio_url ? { fileUrl: audio_url } : null;
          this.formGeneral.script = script;
          this.formGeneral.sub_question.question1 = question1;
          this.formGeneral.sub_question.question2 = question2;

          this.formGeneral.sub_question.question1.audio = question1.audio_url
            ? { fileUrl: question1.audio_url }
            : null;
          this.formGeneral.sub_question.question2.audio = question2.audio_url
            ? { fileUrl: question2.audio_url }
            : null;
        }

        // If type = Comprehension
        if (type_value == "Comprehension") {
          this.formGeneral.name1 = name[0][0];
          this.formGeneral.name2 = name[0][1];
          this.formGeneral.isAnsewr = answer_correct[0];
          this.formGeneral.image = image_url ? { fileUrl: image_url } : null;
          this.formGeneral.answers.forEach(
            (e, index) => (e.value = response.result[`answer${index + 1}`])
          );
        }
        // If type = MultiRead
        if (type_value == "MultiRead") {
          this.formGeneral.name1 = name[0][0];
          this.formGeneral.name2 = name[0][1];
          this.formGeneral.isAnsewr = answer_correct;
          this.formGeneral.image = image_url ? { fileUrl: image_url } : null;
          this.formGeneral.answers.forEach(
            (e, index) => (e.value = response.result[`answer${index + 1}`])
          );
        }
      });
    },
    handleEditItem(item) {
      this.paramsUpdate.params.id = item.Id;
      // this.paramsUpdate.query.no = this.$route.query.no;
      this.$router.push(this.paramsUpdate);
    },
  },
  beforeDestroy() {
    this.formGeneral = {
      leadSentence: "",
      name1: "",
      name2: "",
      isAnsewr: 1,
      verb: "",
      kanji: "",
      audio: null,
      image: null,
      script: "",
      sub_question: {
        question1: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
        question2: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
      },
      answers: [
        {
          id: 1,
          name: "回答1",
          value: "",
        },
        {
          id: 2,
          name: "回答2",
          value: "",
        },
        {
          id: 3,
          name: "回答3",
          value: "",
        },
        {
          id: 4,
          name: "回答4",
          value: "",
        },
      ],
      answersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
      wrongAnswersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
#Audio {
  height: 40px;
  margin-top: 4px;
}

tr td {
  border: 1px solid #ccc;
  border-top: none;
}
</style>